import type { PlaceDto, PlaceInputDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedRequestDto, PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class PlaceService {
  apiName = 'Default';
  

  createByInputDto = (inputDto: PlaceInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/place',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteByPlaceId = (placeId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/place',
      params: { placeId },
    },
    { apiName: this.apiName,...config });
  

  editByInputDto = (inputDto: PlaceInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/place/edit',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: PagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PlaceDto>>({
      method: 'GET',
      url: '/api/app/place',
      params: { skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByIdByPlaceId = (placeId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlaceDto>({
      method: 'GET',
      url: `/api/app/place/by-id/${placeId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
